var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowupicon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 9.614,
  height: 5.497,
  viewBox: "0 0 9.614 5.497"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-ios-arrow-down",
  "data-name": "Icon ionic-ios-arrow-down",
  d: "M4.809,1.657,8.444,5.3a.684.684,0,0,0,.97,0,.693.693,0,0,0,0-.973L5.3.2A.686.686,0,0,0,4.348.18L.2,4.319a.687.687,0,0,0,.97.973Z",
  fill: "currentColor"
})));
export { SvgArrowupicon as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowupicon.999e2a20ca062008788ef6fe8628307e.svg";